import React, { useState } from 'react';
import FirmwareESP32Uploader from './FirmwareESP32Uploader';
import FirmwareSTM32Uploader from './FirmwareSTM32Uploader';
import FirmwareProgressViewer from './FirmwareESP32ProgressViewer'; // 공용으로 쓴다고 가정
import '../css/FirmwareUpload.css';

export default function FirmwareUploadViewr({ deviceId }) {
  const [ESP32devicesToWatch, setESP32DevicesToWatch] = useState([]);
  const [STM32devicesToWatch, setSTM32DevicesToWatch] = useState([]);

  // 중복 제거한 합집합
  const allDevicesToWatch = Array.from(new Set([
    ...ESP32devicesToWatch,
    ...STM32devicesToWatch,
  ]));

  const showProgress = allDevicesToWatch.length > 0;

  return (
    <div className="fw-layout">
      <div className="fw-left">
        <FirmwareSTM32Uploader deviceId={deviceId} onUpload={setSTM32DevicesToWatch} />
        <FirmwareESP32Uploader deviceId={deviceId} onUpload={setESP32DevicesToWatch} />
      </div>

      <div className="fw-right">
        {showProgress && (
          <FirmwareProgressViewer listeningDeviceIds={allDevicesToWatch} />
        )}
      </div>
    </div>
  );
}
